import React from "react";
import Spinner from "../OnboardingComponents/Spinner";

interface CallbackLoadingStateProps {
  loadingStep: number;
  loadingProgress: number;
  loadingMessages: string[];
}

const CallbackLoadingState: React.FC<CallbackLoadingStateProps> = ({
  loadingStep,
  loadingProgress,
  loadingMessages,
}) => {
  return (
    <div className="w-full max-w-sm flex flex-col items-center justify-center">
      <div className="flex items-center justify-center scale-[0.5] -my-10">
        <Spinner />
      </div>
      <h2 className="text-2xl font-semibold text-[#1f2937] mb-2 text-center">
        {loadingMessages[loadingStep]}
      </h2>
      <p className="text-sm text-gray-500 text-center mb-8">
        Securely connecting to your account
      </p>

      <div className="w-full bg-gray-200 rounded-full h-1 overflow-hidden mb-4">
        <div
          className="h-full bg-secondary rounded-full transition-all duration-100 ease-out"
          style={{ width: `${loadingProgress}%` }}
        />
      </div>

      <div className="flex gap-2">
        {loadingMessages.map((_, i) => (
          <div
            key={i}
            className={`rounded-full transition-all duration-500 ${
              i < loadingStep
                ? "w-4 h-1.5 bg-secondary"
                : i === loadingStep
                  ? "w-4 h-1.5 bg-secondary/70"
                  : "w-1.5 h-1.5 bg-gray-200"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default CallbackLoadingState;